import React from 'react';
import { Button } from './ui/button';
import { ClipboardCheck, FileText, Award } from 'lucide-react';

const ProcessSection = ({ openPopup }) => {
  const steps = [
    {
      number: "01",
      icon: ClipboardCheck,
      title: "Free Consultation & Search",
      description: "We begin with a detailed consultation to understand your brand, business goals, and trademark needs. Our experts assess your mark's registrability, conduct a comprehensive search of federal databases, state registries, and common law uses to identify potential conflicts.",
      actions: ["Brand discussion & assessment", "Federal database search", "State registry & common law review", "Detailed conflict report delivery"]
    },
    {
      number: "02",
      icon: FileText,
      title: "Application Preparation & Filing",
      description: "We meticulously prepare your trademark application, selecting proper classifications, drafting descriptions, and gathering required specimens. Your complete application is then electronically filed with the USPTO, and you receive a filing receipt with your application serial number.",
      actions: ["Class identification & description", "Specimen & document collection", "Electronic TEAS filing", "Filing receipt confirmation"]
    },
    {
      number: "03",
      icon: Award,
      title: "Monitoring & Registration",
      description: "The USPTO examines your application for legal compliance and conflicts. We monitor your application throughout the process and handle any office actions. Upon approval, your mark is published for opposition, and you receive your official USPTO trademark registration certificate with nationwide federal protection.",
      actions: ["Application monitoring & tracking", "Office action responses", "Opposition period management", "Certificate & registration completion"]
    }
  ];

  return (
    <section className="process-section" id="process">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Registration Process</span>
          <h2 className="section-title">
            Your Trademark Journey
            <span className="title-highlight"> Step by Step</span>
          </h2>
          <p className="section-description">
            We guide you through every stage of the trademark registration process with 
            transparency, expertise, and dedicated support. Here's what to expect when you 
            choose Trademark Texticon.
          </p>
        </div>

        <div className="process-timeline">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="process-step">
                <div className="process-step-connector">
                  {index < steps.length - 1 && <div className="process-line"></div>}
                </div>
                
                <div className="process-step-content">
                  <div className="process-step-number">{step.number}</div>
                  
                  <div className="process-card">
                    <div className="process-card-header">
                      <div className="process-icon">
                        <Icon size={28} />
                      </div>
                      <div className="process-header-text">
                        <h3 className="process-title">{step.title}</h3>
                      </div>
                    </div>
                    
                    <p className="process-description">{step.description}</p>
                    
                    <div className="process-actions">
                      <div className="process-actions-title">Key Actions:</div>
                      <ul className="process-actions-list">
                        {step.actions.map((action, idx) => (
                          <li key={idx} className="process-action-item">
                            <span className="action-bullet">▸</span>
                            {action}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="process-cta-section">
          <div className="process-cta-card">
            <h3 className="process-cta-title">Ready to Start Your Trademark Registration?</h3>
            <p className="process-cta-text">
              Our expert team is standing by to begin protecting your brand today. 
              Get started with a free consultation and discover how simple trademark 
              registration can be with the right partner.
            </p>
            <Button onClick={openPopup} className="process-cta-button" size="lg">
              Begin My Trademark Application
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
